import { render, staticRenderFns } from "./ConsolidationDetail.vue?vue&type=template&id=2d71820e&scoped=true"
import script from "./ConsolidationDetail.vue?vue&type=script&lang=js"
export * from "./ConsolidationDetail.vue?vue&type=script&lang=js"
import style1 from "./ConsolidationDetail.vue?vue&type=style&index=1&id=2d71820e&prod&media=print&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d71820e",
  null
  
)

export default component.exports